import { mapListToRecords, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import { Radio, radioSchema } from '@sophocles/entities/Radio/radioRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { validICCID, validMACAddress } from '@sophocles/utils/validation';
import { fromJS } from 'immutable';
import { normalize } from 'normalizr';

/* RECEIVE ACTIONS */
export const RECEIVE_RADIOS = 'RECEIVE_RADIOS';
export function receiveRadios(json) {
  return {
    type: RECEIVE_RADIOS,
    radios: mapListToRecords(json, Radio),
  };
}

/* REQUEST ACTIONS */
// unused
export const REQUEST_RADIO_LOOKUP = 'REQUEST_RADIO_LOOKUP';
function requestRadioLookup(iccid) {
  return {
    type: REQUEST_RADIO_LOOKUP,
    iccid,
  };
}

export function fetchRadioSearches(iccid) {
  return dispatch => {
    dispatch(requestRadioLookup(iccid));
    const params = {};
    if (/[a-fA-F]/.test(iccid)) {
      params.mac_address__icontains = iccid.toLowerCase().replace('-', '').replace(':', '');
    } else {
      params.iccid__icontains = iccid;
    }

    return apiClient
      .get('/radios/search/', { params })
      .then(checkHttpStatus)
      .then(response => fromJS(response.data.results))
      .catch(error => dispatch(genericErrorAction(error, REQUEST_RADIO_LOOKUP)));
  };
}

/* FETCH ACTIONS */

export function fetchRadioLookup(iccid) {
  const isMAC = validMACAddress.test(iccid);

  const params = {};
  if (isMAC) {
    params.mac_address = iccid.replace('-', '').replace(':', '');
  } else {
    params.iccid = iccid;
  }

  return dispatch => {
    dispatch(requestRadioLookup(iccid));
    return apiClient.get('/radios/lookup/', { params }).then(response => response.data);
  };
}

/* Create Actions */
export const CREATE_RADIO = 'CREATE_RADIO';
function sayCreateRadio(values) {
  return {
    type: CREATE_RADIO,
    values: values,
  };
}

export function createRadio(values) {
  return dispatch => {
    dispatch(sayCreateRadio(values));
    return apiClient
      .post(`/radios/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, radioSchema))
      .then(json => dispatch(receiveRadios(json.entities.radios)))
      .catch(error => dispatch(genericErrorAction(error, CREATE_RADIO)));
  };
}

/* Edit Actions */
export const EDIT_RADIO = 'EDIT_RADIO';
export function editRadio(radio) {
  return {
    type: EDIT_RADIO,
    radio,
  };
}

export function patchRadio(radio_id, values) {
  return dispatch => {
    dispatch(editRadio(radio_id));
    return apiClient
      .patch(`/radios/${radio_id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, radioSchema))
      .then(json => dispatch(receiveRadios(json.entities.radios)))
      .catch(error => dispatch(genericErrorAction(error, EDIT_RADIO)));
  };
}

export const DELETE_RADIO = 'DELETE_RADIO';
export function sayDeleteRadio(radio_id) {
  return {
    type: DELETE_RADIO,
    radio: radio_id,
  };
}

const receiver = (dispatch, json) => dispatch(receiveRadios(json.entities.radios));

export const handleRadioSocketActions = websocketsHandlerFactory(receiver, sayDeleteRadio, radioSchema);
